import Settings from '../components/routes/settings/Settings.vue'
import EmailSettings from '../components/routes/settings/EmailSettings.vue'
import PersonalInfoSettings from '../components/routes/settings/PersonalInfoSettings.vue'
import PasswordSettings from '../components/routes/settings/PasswordSettings.vue'
import GdprSettings from '../components/routes/settings/GdprSettings'

const settingsRoutes = [{
  name: 'settings',
  path: '/settings',
  component: Settings,
  redirect: {
    name: 'personalInfoSettings'
  },
  children: [{
    name: 'personalInfoSettings',
    path: 'personal-info',
    component: PersonalInfoSettings
  },
  {
    name: 'emailSettings',
    path: 'email',
    component: EmailSettings
  },
  {
    name: 'passwordSettings',
    path: 'password',
    component: PasswordSettings
  },
  {
    name: 'gdprSettings',
    path: 'dsgvo',
    component: GdprSettings
  }
  ]
}]

export default settingsRoutes
